import React from 'react';

const DEFAULT_VIDEO =
  'https://videos.pexels.com/video-files/2169880/2169880-uhd_2560_1440_30fps.mp4';

const VideoHero = ({
  title,
  subtitle,
  poster = '/images/banner1.jpg',
  videoSrc = DEFAULT_VIDEO,
  compact = false,
  showBrand = false,
  children,
}) => {
  return (
    <section className={`gd-hero ${compact ? 'gd-hero-compact' : ''}`} aria-label="GoaDeals hero">
      <video className="gd-hero-video" autoPlay muted loop playsInline poster={poster}>
        <source src={videoSrc} type="video/mp4" />
      </video>
      <div className="gd-hero-shade" />
      <div className="gd-hero-content">
        {showBrand && <img src="/images/logo.png" alt="GoaDeals" className="gd-hero-brand" />}
        {title && <h1 className="gd-hero-title">{title}</h1>}
        {subtitle && <p className="gd-hero-lead">{subtitle}</p>}
        {children && <div className="gd-hero-cta">{children}</div>}
      </div>
    </section>
  );
};

export default VideoHero;
